import { FC } from 'react';
import { Box, SvgIconProps } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { ItemBadge, StyledMenuItem } from './styled';

interface MenuItemProps {
  title: string;
  count?: number;
  Icon: FC<SvgIconProps>;
  onClick: () => void;
}

const color = '#fff';

export const MenuItem = ({ title, count, Icon, onClick }: MenuItemProps) => (
  <Box display="flex" p={2} onClick={onClick}>
    <StyledMenuItem>
      <Icon fill={color} style={{ fontSize: 18 }} />
      <SText size="sm" title={title} fontColor={color} weight="semibold" />
    </StyledMenuItem>
    {count > 0 && <ItemBadge>{count}</ItemBadge>}
  </Box>
);
